/* eslint-disable no-sparse-arrays */
import React from 'react'
import * as AppUrl from './appUrl'
import history from '../routes/history'
import iconDashBoard from '../assets/images/nav_dashBoard.png'
import iconMapping from '../assets/images/nav_mapping.png'
import iconMessage from '../assets/images/nav_message.png'
import iconApi from '../assets/images/nav_api.png'
import iconPermission from '../assets/images/nav_permission.png'
import iconTools from '../assets/images/nav_tools.png'
import iconCustomer from '../assets/images/nav_customer.png'
import iconReportManagement from '../assets/images/nav_reportManagement.png'
import iconReportPage from '../assets/images/nav_reportPage.png'
import iconPBIReportPage from '../assets/images/nav_powerbiReport.png'
import marketing from '../assets/images/nav_marketing.png'
import miceCad from '../assets/images/nav_miceCad.png'
import iconThemeSetting from '../assets/images/nav_setting.png'
import driveManagement from '../assets/images/nav_drive.png'
import chatbi from '../assets/images/chatbi.svg'

import i18n from 'i18next'
import '../i18n/config'

const {t} = i18n
const getMenus = () => {
  return [
    {
      label: (
        <>
          <img src={iconDashBoard} alt=""/>
          {t(`menu.dashboard`)}
        </>
      ),
      key: 'home',
      onClick: () => {history.push(AppUrl.HOME)},
    },
    {
      label: (
        <>
          <img src={iconCustomer} alt=""/>
          {t(`menu.customer`)}
        </>
      ),
      key: 'customer',
      children: [
        {
          label: (
            <>
              {/*<img src={iconCustomer} alt=""/>*/}
              {t(`menu.customerManagement`)}
            </>
          ),
          key: 'customerManagement',
          onClick: () => {history.push(AppUrl.CUSTOMERMANAGEMENT)},
        },
        {
          label: (
            <>
              {/*<img src={iconCustomer} alt=""/>*/}
              {t(`menu.businessType`)}
            </>
          ),
          key: 'businessType',
          onClick: () => {history.push(AppUrl.BUSINESSTYPE)},
        },
      ]
    },
    {
      label: (
        <>
          <img src={iconApi} alt=""/>
          {t(`menu.connect`)}
        </>
      ),
      key: 'apiManage',
      children: [
        {
          label: (
            <>
              {/*<img src={iconApi} alt=""/>*/}
              {t(`menu.apiManagement`)}
            </>
          ),
          key: 'apiManagement',
          onClick: () => {history.push(AppUrl.APIMANAGEMENT)},
        },
        {
          label: (
            <>
              {/*<img src={iconApi} alt=""/>*/}
              {t(`menu.dataTarget`)}
            </>
          ),
          key: 'dataTarget',
          onClick: () => {history.push(AppUrl.DATATARGET)},
        },
        {
          label: (
            <>
              {/*<img src={iconApi} alt=""/>*/}
              {t(`menu.dataSource`)}
            </>
          ),
          key: 'dataSource',
          onClick: () => {history.push(AppUrl.DATASOURCE)},
        },
        {
          label: (
            <>
              {/*<img src={iconApi} alt=""/>*/}
              {t(`menu.azureAppRegistration`)}
            </>
          ),
          key: 'azureAppRegistration',
          onClick: () => {history.push(AppUrl.AZUREAPPREGISTRATION)},
        },
        {
          label: (
            <>
              {/*<img src={iconApi} alt=""/>*/}
              {t(`menu.azureKeyVault`)}
            </>
          ),
          key: 'azureKeyVault',
          onClick: () => {history.push(AppUrl.AZUREKEYVAULT)},
        },
      ]
    },
    {
      label: (
        <>
          <img src={iconMapping} alt=""/>
          {t(`menu.mappingManagement`)}
        </>
      ),
      key: 'mappingManagement',
      onClick: () => {history.push(AppUrl.MAPPINGMANAGEMENT)},
    },
    {
      label: (
        <>
          <img src={iconMessage} alt=""/>
          {t(`menu.monitor`)}
        </>
      ),
      key: 'monitor',
      children: [
        {
          label: (
            <>
              {/*<img src={iconMessage} alt=""/>*/}
              {t(`menu.messageManagement`)}
            </>
          ),
          key: 'messageManagement',
          onClick: () => {history.push(AppUrl.MESSAGEMANAGEMENT)},
        },
        {
          label: (
            <>
              {/*<img src={iconMessage} alt=""/>*/}
              {t(`menu.messageDetails`)}
            </>
          ),
          key: 'messageDetails',
          onClick: () => {history.push(AppUrl.MESSAGEDETAILS)},
        },
      ]
    },
    {
      label: (
        <>
          <img src={iconTools} alt=""/>
          {t(`menu.apiTools`)}
        </>
      ),
      key: 'apiTools',
      children: [
        {
          label: (
            <>
              {/*<img src={iconTools} alt=""/>*/}
              {t(`menu.jobManagement`)}
            </>
          ),
          key: 'jobManagement',
          onClick: () => {history.push(AppUrl.JOBMANAGEMENT)},
        },
        {
          label: (
            <>
              {/*<img src={iconTools} alt=""/>*/}
              {t(`menu.groovyManagement`)}
            </>
          ),
          key: 'groovyManagement',
          onClick: () => {history.push(AppUrl.GROOVYMANAGEMENT)},
        },
        {
          label: (
            <>
              {/*<img src={iconTools} alt=""/>*/}
              {t(`menu.formulaInfo`)}
            </>
          ),
          key: 'formulaInfo',
          onClick: () => {history.push(AppUrl.FORMULAINFO)},
        },
        {
          label: (
            <>
              {/*<img src={iconTools} alt=""/>*/}
              {t(`menu.formulaType`)}
            </>
          ),
          key: 'formulaType',
          onClick: () => {history.push(AppUrl.FORMULATYPE)},
        },
        // {
        //   label: (
        //     <>
        //       <img src={iconTools} alt=""/>
        //       {t(`menu.rulesManagement`)}
        //     </>
        //   ),
        //   key: 'rulesManagement',
        //   onClick: () => {history.push(AppUrl.RULESMANAGEMENT)},
        // },
        {
          label: (
            <>
              {/*<img src={iconTools} alt=""/>*/}
              {t(`menu.emailManagement`)}
            </>
          ),
          key: 'emailManagement',
          onClick: () => {history.push(AppUrl.EMAILMANAGEMENT)},
        },
        // {
        //   label: (
        //     <>
        //       {/*<img src={iconTools} alt=""/>*/}
        //       {t(`menu.sqlBot`)}
        //     </>
        //   ),
        //   key: 'sqlBot',
        //   onClick: () => {history.push(AppUrl.SQLBOT)},
        // },
      ]
    },
    {
      label: (
        <>
          <img src={iconPermission} alt=""/>
          {t(`menu.permission`)}
        </>
      ),
      key: 'permission',
      children: [
        {
          label: (
            <>
              {/*<img src={iconPermission} alt=""/>*/}
              {t(`menu.permissionManagement`)}
            </>
          ),
          key: 'permissionManagement',
          onClick: () => {history.push(AppUrl.PERMISSIONMANAGEMENT)},
        },
        {
          label: (
            <>
              {/*<img src={iconPermission} alt=""/>*/}
              {t(`menu.userManagement`)}
            </>
          ),
          key: 'userManagement',
          onClick: () => {history.push(AppUrl.USERMANAGEMENT)},
        },
        {
          label: (
            <>
              {/*<img src={iconPermission} alt=""/>*/}
              {t(`menu.roleManagement`)}
            </>
          ),
          key: 'roleManagement',
          onClick: () => {history.push(AppUrl.ROLEMANAGEMENT)},
        }
      ]
    },
    {
      label: (
        <>
          <img src={iconReportManagement} alt=""/>
          {t(`menu.auditLogs`)}
        </>
      ),
      key: 'auditLogs',
      onClick: () => {history.push(AppUrl.AUDITLOGS)}
    },
    {
      label: (
        <>
          <img src={iconReportManagement} alt=""/>
          {t(`menu.reportHardManagement`)}
        </>
      ),
      key: 'reportHardManagement',
      children: [
        {
          label: (
            <>
              {t(`menu.reportManagement`)}
            </>
          ),
          key: 'reportManagement',
          onClick: () => {history.push(AppUrl.REPORTMANAGEMENT)},
        },
        {
          label: (
            <>
              {t(`menu.reportTag`)}
            </>
          ),
          key: 'reportTag',
          onClick: () => {history.push(AppUrl.REPORTTAG)},
        },
      ]
    },
    {
      label: (
        <>
          <img src={iconReportPage} alt=""/>
          {t(`menu.reportPage`)}
        </>
      ),
      key: 'reportPage',
    },
    {
      label: (
        <>
          <img src={iconPBIReportPage} alt=""/>
          {t(`menu.pbiReportPage`)}
        </>
      ),
      key: 'pbiReportPage',
    },
    {
      label: (
        <>
          <img src={iconMessage} alt=""/>
          {t(`menu.dataFlowMonitoring`)}
        </>
      ),
      key: 'dataFlowMonitoring',
      children: [
        {
          label: (
            <>
              {t(`menu.dataFlowMonitoringConfig`)}
            </>
          ),
          key: 'dataFlowMonitoringConfig',
          onClick: () => {history.push(AppUrl.DATAFLOWMONITORINGCONFIG)},
        },
        {
          label: (
            <>
              {t(`menu.dataFlowLog`)}
            </>
          ),
          key: 'dataFlowLog',
          onClick: () => {history.push(AppUrl.DATAFLOWLOG)},
        },
      ]
    },
    {
      label: (
        <>
          <img src={marketing} alt=""/>
          {t(`menu.marketingManagement`)}
        </>
      ),
      key: 'marketingManagement',
      children: [
        {
          label: (
            <>
              {t(`menu.marketingGroupManagement`)}
            </>
          ),
          key: 'marketingGroupManagement',
          onClick: () => {history.push(AppUrl.MARKETINGGROUPMANAGEMENT)},
        },
        {
          label: (
            <>
              {t(`menu.resourcePool`)}
            </>
          ),
          key: 'resourcePool',
          onClick: () => {history.push(AppUrl.RESOURCEPOOL)},
        },
        // {
        //   label: (
        //     <>
        //       {t(`menu.addressBook`)}
        //     </>
        //   ),
        //   key: 'addressBook',
        //   onClick: () => {history.push(AppUrl.ADDRESSBOOK)},
        // },
        {
          label: (
            <>
              {t(`menu.shortLink`)}
            </>
          ),
          key: 'shortLink',
          onClick: () => {history.push(AppUrl.SHORTLINK)},
        },
        {
          label: (
            <>
              {t(`menu.fatigueConfig`)}
            </>
          ),
          key: 'fatigueConfig',
          onClick: () => {history.push(AppUrl.FATIGUECONFIG)},
        },
        {
          label: (
            <>
              {t(`menu.sms`)}
            </>
          ),
          key: 'smsManagement',
          children: [ 
            {
              label: (
                <>
                  {t(`menu.smsSignature`)}
                </>
              ),
              key: 'smsSignature',
              onClick: () => {history.push(AppUrl.SMSSIGNATURE)},
            },
            {
              label: (
                <>
                  {t(`menu.smsTemplate`)}
                </>
              ),
              key: 'smsTemplate',
              onClick: () => {history.push(AppUrl.SMSTEMPLATE)},
            },
            {
              label: (
                <>
                  {t(`menu.smsManagement`)}
                </>
              ),
              key: 'smsManagement',
              onClick: () => {history.push(AppUrl.SMSMANAGEMENT)},
            }
          ]
        },
        {
          label: (
            <>
              {t(`menu.emailSend`)}
            </>
          ),
          key: 'emailSend',
          children: [
            // {
            //   label: (
            //     <>
            //       {t(`menu.emailAddress`)}
            //     </>
            //   ),
            //   key: 'emailAddress',
            //   onClick: () => {history.push(AppUrl.EMAILADDRESS)},
            // },
            {
              label: (
                <>
                  {t(`menu.emailTemplate`)}
                </>
              ),
              key: 'emailTemplate',
              onClick: () => {history.push(AppUrl.EMAILTEMPLATE)},
            },
            // {
            //   label: (
            //     <>
            //       {t(`menu.emailSendOnline`)}
            //     </>
            //   ),
            //   key: 'emailSendOnline',
            //   onClick: () => {history.push(AppUrl.EMAILSENDONLINE)},
            // },
            {
              label: (
                <>
                  {t(`menu.emailList`)}
                </>
              ),
              key: 'emailList',
              onClick: () => {history.push(AppUrl.EMAILLIST)},
            },
          ]
        },
        {
          label: (
            <>
              {t(`menu.manualCall`)}
            </>
          ),
          key: 'manualCall',
          children: [
            {
              label: (
                <>
                  {t(`menu.remarkTemplateList`)}
                </>
              ),
              key: 'remarkTemplateList',
              onClick: () => {history.push(AppUrl.REMARKTEMPLATELIST)},
            },
            {
              label: (
                <>
                  {t(`menu.manualCallManagement`)}
                </>
              ),
              key: 'manualCallManagement',
              onClick: () => {history.push(AppUrl.MANUALCALLMANAGEMENT)},
            },
          ]
        },
        {
          label: (
            <>
              {t(`menu.intelligentCall`)}
            </>
          ),
          key: 'intelligentCall',
          children: [
            {
              label: (
                <>
                  {t(`menu.intelligentCallModel`)}
                </>
              ),
              key: 'intelligentCallModel',
              onClick: () => {history.push(AppUrl.INTELLIGENTCALLMODEL)},
            },
            {
              label: (
                <>
                  {t(`menu.intelligentCallManagement`)}
                </>
              ),
              key: 'intelligentCallManagement',
              onClick: () => {history.push(AppUrl.INTELLIGENTCALLMANAGEMENT)},
            },
          ]
        },
      ]
    },
    {
      label: (
        <>
          <img src={miceCad} alt=""/>
          {t(`menu.miceCad`)}
        </>
      ),
      key: 'miceCad',
      children: [
        {
          label: (
            <>
              {t(`menu.miceCadOea`)}
            </>
          ),
          key: 'miceCadOea',
          onClick: () => {history.push(AppUrl.MICECADOEA)},
        },
        {
          label: (
            <>
              {t(`menu.miceCadOeaSchedule`)}
            </>
          ),
          key: 'miceCadOeaSchedule',
          onClick: () => {history.push(AppUrl.MICECADOEASCHEDULE)},
        }
      ]
    },
    {
      label: (
        <>
          <img src={driveManagement} alt=""/>
          {t(`menu.driveManagement`)}
        </>
      ),
      key: 'driveManagement',
      children: [
        {
          label: (
            <>
              {t(`menu.driveSearch`)}
            </>
          ),
          key: 'driveSearch',
          onClick: () => {history.push(AppUrl.DRIVESEARCH)},
        },
        {
          label: (
            <>
              {t(`menu.driveList`)}
            </>
          ),
          key: 'driveList',
          onClick: () => {history.push(AppUrl.DRIVELIST)},
        },
        {
          label: (
            <>
              {t(`menu.drivePermission`)}
            </>
          ),
          key: 'drivePermission',
          onClick: () => {history.push(AppUrl.DRIVEPERMISSION)},
        }
      ]
    },
    {
      label: (
        <>
          <img src={chatbi} alt="" style={{color: 'white'}}/>
          {t(`menu.intelligentQuery`)}
        </>
      ),
      key: 'intelligentQuery',
      children: [
        // {
        //   label: (
        //     <>
        //       {/*<img src={iconTools} alt=""/>*/}
        //       {t(`menu.chatbi`)}
        //     </>
        //   ),
        //   key: 'chat',
        //   onClick: () => {history.push(AppUrl.CHATBI)},
        // },
        {
          label: t('menu.harness'),
          key: 'harness',
          onClick: () => {history.push(AppUrl.HARNESS)},
        },
        {
          label: (
            <>
              {t(`menu.terminologyConfig`)}
            </>
          ),
          key: 'terminologyConfig',
          onClick: () => {history.push(AppUrl.TERMINOLOGYCONFIG)},
        },
        {
          label: (
            <>
              {t(`menu.sqlExample`)}
            </>
          ),
          key: 'sqlExample',
          onClick: () => {history.push(AppUrl.SQLEXAMPLE)},
        },
        {
          label: (
            <>
              {t(`menu.queryAudit`)}
            </>
          ),
          key: 'queryAudit',
          onClick: () => {history.push(AppUrl.QUERYAUDIT)},
        }
      ]
    },
    {
      label: (
        <>
          <img src={iconThemeSetting} alt=""/>
          {t(`menu.themeSetting`)}
        </>
      ),
      key: 'themeSetting',
      onClick: () => {history.push(AppUrl.THEMESETTING)}
    },
  ]
}

export default {getMenus}
